import React from "react";

export type OpenLockIconProps = React.SVGProps<SVGSVGElement> & {
  size?: number | string;
  color?: string;
  title?: string;
};

const OpenLockIcon: React.FC<OpenLockIconProps> = ({
  size = 26,
  color = "currentColor",
  title = "Lock icon",
  className,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill={color}
      role="img"
      aria-label={title}
      className={className}
      {...props}
    >
      <title>{title}</title>
      <path d="M 7 0 C 4.789063 0 2.878906 0.917969 1.6875 2.40625 C 0.496094 3.894531 0 5.824219 0 7.90625 L 0 11 L 3 11 L 3 7.90625 C 3 6.328125 3.390625 5.085938 4.03125 4.28125 C 4.671875 3.476563 5.542969 3 7 3 C 8.460938 3 9.328125 3.449219 9.96875 4.25 C 10.609375 5.050781 11 6.308594 11 7.90625 L 11 9 L 14 9 L 14 7.90625 C 14 5.8125 13.472656 3.863281 12.28125 2.375 C 11.089844 0.886719 9.207031 0 7 0 Z M 9 10 C 7.34375 10 6 11.34375 6 13 L 6 23 C 6 24.65625 7.34375 26 9 26 L 23 26 C 24.65625 26 26 24.65625 26 23 L 26 13 C 26 11.34375 24.65625 10 23 10 Z M 16 15 C 17.105469 15 18 15.894531 18 17 C 18 17.738281 17.597656 18.371094 17 18.71875 L 17 21 C 17 21.550781 16.550781 22 16 22 C 15.449219 22 15 21.550781 15 21 L 15 18.71875 C 14.402344 18.371094 14 17.738281 14 17 C 14 15.894531 14.894531 15 16 15 Z" />
    </svg>
  );
};

export default OpenLockIcon;
